import {
  YEARS_CREATE_FAIL,
  YEARS_CREATE_REQUEST,
  YEARS_CREATE_SUCCESS,
  YEARS_UPDATE_FAIL,
  YEARS_UPDATE_REQUEST,
  YEARS_UPDATE_SUCCESS,
  YEARS_PATCH_FAIL,
  YEARS_PATCH_REQUEST,
  YEARS_PATCH_SUCCESS,
  YEARS_LIST_FAIL,
  YEARS_LIST_REQUEST,
  YEARS_LIST_SUCCESS,
  YEARS_SINGLE_FAIL,
  YEARS_SINGLE_SUCCESS,
  YEARS_SINGLE_REQUEST,
} from "../constants/yearsConstants";
import axios from "axios";
import createAuthConfig from "../utils/createAuthConfig";

// Define the API_URL using the environment variable
const API_URL = process.env.REACT_APP_API_URL;

export const listYears = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: YEARS_LIST_REQUEST,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.get(`${API_URL}/api/years/`, config);

    dispatch({
      type: YEARS_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: YEARS_LIST_FAIL,
      payload: message,
    });
  }
};

export const getYearByIdAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: YEARS_SINGLE_REQUEST,
    });
    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.get(`${API_URL}/api/years/year/${id}`, config);

    dispatch({
      type: YEARS_SINGLE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: YEARS_SINGLE_FAIL,
      payload: message,
    });
  }
};

export const createYearAction = (meyear) => async (dispatch, getState) => {
  try {
    dispatch({
      type: YEARS_CREATE_REQUEST,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.post(
      `${API_URL}/api/years/year/create`,
      { meyear },
      config
    );

    dispatch({
      type: YEARS_CREATE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: YEARS_CREATE_FAIL,
      payload: message,
    });
  }
};

// Patch-style update for Year — same protocol as Day's patchDayAction.
export const patchYearAction =
  (id, { patches, clientFieldTimestamps, deviceId, socketId }) =>
  async (dispatch) => {
    try {
      dispatch({ type: YEARS_PATCH_REQUEST });
      const config = createAuthConfig();
      const { data } = await axios.patch(
        `${API_URL}/api/years/year/${id}`,
        { patches, clientFieldTimestamps, deviceId, socketId },
        config,
      );
      dispatch({ type: YEARS_PATCH_SUCCESS, payload: data });
      return data;
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: YEARS_PATCH_FAIL, payload: message });
      throw new Error(message);
    }
  };

export const updateYearAction = (id, meyear) => async (dispatch, getState) => {
  try {
    dispatch({
      type: YEARS_UPDATE_REQUEST,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.put(
      `${API_URL}/api/years/year/${id}`,
      {
        meyear,
      },
      config
    );

    dispatch({
      type: YEARS_UPDATE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: YEARS_UPDATE_FAIL,
      payload: message,
    });
  }
};
